import React from 'react';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { makeStyles } from '@mui/styles';
import { IconButton, Tooltip } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { DataTable } from 'components';

const useStyles = makeStyles((theme) => ({
	root: {},
	content: {
		padding: 0,
	},
	inner: {
		minWidth: 700,
	},
	nameCell: {
		display: 'flex',
		alignItems: 'center',
	},
	avatar: {
		height: 42,
		width: 42,
		marginRight: theme.spacing(1),
	},
	actions: {
		padding: theme.spacing(1),
		justifyContent: 'flex-end',
	},
	primaryButton: {
		color: theme.palette.primary.main
	},
	okCell: {
		backgroundColor: '#a5d6a7',
	},
	nokCell: {
		backgroundColor: '#ef9a9a',
	}
}));

const OverallSiteSummaryTable = (props) => {
	const { data, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();

	const _getTableColumns = () => (
		[
			{
				name: 'siteId',
				label: 'Site Id',
				options: {
					display: true,
					filterType: 'textField',
					customFilterListOptions: {
						render: v => `Site Id - ${v}`
					},
				}
			},
			{
				name: 'siteName',
				label: 'Site Name',
				options: {
					display: true,
					filterType: 'textField',
					customFilterListOptions: {
						render: v => `Site Name - ${v}`
					},
				}
			},
			{
				name: 'commissioningDate',
				label: 'Commissioning Date',
				options: {
					display: true,
					filterType: 'textField',
					customFilterListOptions: {
						render: v => `Commissioning Date - ${v}`
					},
					customBodyRender: (value, tableMeta, updateValue) => <>{moment(value).format('DD-MM-YYYY HH:mm:ss').toString()}</>
				}
			},
			{
				name: 'currentStatus',
				label: 'Current Status',
				options: {
					display: true,
					filterType: 'dropdown',
					customFilterListOptions: {
						render: v => `Current Status - ${v}`
					},
				}
			},
			{
				name: 'overallSiteStatus',
				label: 'Overall Site Status',
				options: {
					display: true,
					filterType: 'dropdown',
					customFilterListOptions: {
						render: v => `Overall Site Status - ${v}`
					},
					setCellProps: value => ({
						className: clsx({
							[classes.okCell]: value === 'OK',
							[classes.nokCell]: value === 'NOK'
						})
					}),
				}
			},
			{
				name: 'performanceStatus',
				label: 'Performance Status',
				options: {
					display: true,
					filterType: 'dropdown',
					customFilterListOptions: {
						render: v => `Performance Status - ${v}`
					},
					setCellProps: value => ({
						className: clsx({
							[classes.okCell]: value === 'OK',
							[classes.nokCell]: value === 'NOK'
						})
					}),
				}
			},
			{
				name: 'alarmStatus',
				label: 'Alarm Status',
				options: {
					display: true,
					filterType: 'dropdown',
					customFilterListOptions: {
						render: v => `Alarm Status - ${v}`
					},
					setCellProps: value => ({
						className: clsx({
							[classes.okCell]: value === 'OK',
							[classes.nokCell]: value === 'NOK'
						})
					}),
				}
			},
			{
				name: 'radioStatus',
				label: 'Radio Configuration Status',
				options: {
					display: true,
					filterType: 'dropdown',
					customFilterListOptions: {
						render: v => `Radio Configuration Status - ${v}`
					},
					setCellProps: value => ({
						className: clsx({
							[classes.okCell]: value === 'OK',
							[classes.nokCell]: value === 'NOK'
						})
					}),
				}
			},
			{
				name: 'coreStatus',
				label: 'Core Configuration Status',
				options: {
					display: true,
					filterType: 'dropdown',
					customFilterListOptions: {
						render: v => `Core Configuration Status - ${v}`
					},
					setCellProps: value => ({
						className: clsx({
							[classes.okCell]: value === 'OK',
							[classes.nokCell]: value === 'NOK'
						})
					}),
				}
			},
		]
	);

	return (
		<div {...rest} className={clsx(classes.root)}>
			<DataTable
				id="FaultManagementTable"
				title="Summary"
				data={data}
				columns={_getTableColumns()}
				rowsPerPage={10}
				tableBodyMaxHeight="30em"
				tableBodyCellMaxWidth="250"
			/>
		</div>
	);
};

OverallSiteSummaryTable.propTypes = {
	data: PropTypes.array.isRequired
};

export default OverallSiteSummaryTable;
